// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // serviceEndPoint : 'http://localhost:8000/api', // production server
  serviceEndPoint : 'https://gtw.fohss.lk/api', // production server
  // serviceEndPoint : 'https://dewgtw.fohss.lk/api', // Development server
  faculty_url: 'https://hss.ruh.ac.lk',
  contact_email: 'sysadmin@hss.ruh.ac.lk',
  itemsPerPage: 10,
  faculty_id: 1
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
